var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestBuyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320.95,
    height: 187.59,
    viewBox: "0 0 320.95 187.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Best_Buy_logo_2018",
    transform: "translate(-137.5 -22.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2998",
    d: "M137.5,29.631v80.982h42.4c16.689,0,32.111-5.857,32.111-23.063,0-11.631-8.379-16.941-17.6-19.72,5.615-2.252,11.985-6.984,11.985-16.9,0-12.7-12.6-21.3-29.557-21.3H137.5Zm25.975,18.861h9.55c3.888,0,6.852,3.045,6.852,6.136,0,2.871-3.08,5.945-6.852,5.945h-9.55V48.492Zm0,28.888h12.606c4.4,0,8.093,3.342,8.093,7.162,0,4.057-3.454,7.425-8.857,7.425H163.475V77.381Z",
    transform: "translate(0 -4.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3005",
    d: "M202.961,309.475v80.982h42.4c16.689,0,32.111-5.857,32.111-23.063,0-11.631-8.379-16.941-17.6-19.72,5.615-2.252,11.985-6.984,11.985-16.9,0-12.7-12.6-21.3-29.557-21.3Zm25.975,18.861h9.55c3.888,0,6.852,3.045,6.852,6.136,0,2.871-3.08,5.945-6.852,5.945h-9.55Zm0,28.888h12.606c4.4,0,8.093,3.342,8.093,7.162,0,4.057-3.454,7.425-8.857,7.425H228.936Z",
    transform: "translate(-44.451 -194.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3007",
    d: "M376.015,110.583V29.6h65.321V49.159H401.914V59.778h32.011V78.114H401.914V91.1h39.422v19.482Z",
    transform: "translate(-161.963 -4.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3009",
    d: "M617.584,108c18.386,0,33.093-10.488,33.093-27.483C650.678,53.093,615,57.313,615,48.773c0-3.3,3.469-5.049,7.027-5.049a17.2,17.2,0,0,1,10.562,4.04l15.351-14.617C641.8,27.3,632.1,22.39,619.035,22.39c-19.619,0-32.454,11.644-32.454,25.69,0,27.778,35.168,23.746,35.168,32.462,0,3.055-2.939,6.129-8.271,6.129-6.053,0-10.848-3.654-14.579-6.754L583.458,94.639C589.675,100.7,599.658,108,617.584,108Z",
    transform: "translate(-302.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3011",
    d: "M809.927,110.583v-61.5H788.536V29.6h68.759V49.083H835.9v61.5Z",
    transform: "translate(-442.086 -4.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3013",
    d: "M437.9,309.3h25.9v48.513c0,4.926,4.9,9.466,10.015,9.466a9.889,9.889,0,0,0,9.7-9.725V309.3h25.823V357.22c0,19.016-15.788,34.186-36.2,34.186A35.005,35.005,0,0,1,437.9,356.184Z",
    transform: "translate(-203.99 -194.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3015",
    d: "M695.567,390.279V361.341L665.126,309.3h26.2l17.224,27.885L725.838,309.3H752.1l-30.559,52.343v28.64Z",
    transform: "translate(-358.285 -194.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3017",
    d: "M903.791,447.389l-15.28,15.28V483.3l15.28,15.28h64.633V447.389Z",
    transform: "translate(-509.974 -288.596)",
    fill: "#ffed31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3024",
    d: "M1241.4,1528.15a3.438,3.438,0,1,1-3.438-3.438A3.438,3.438,0,0,1,1241.4,1528.15Z",
    transform: "translate(-850.095 -1343.773)",
    fill: "#1c252c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestBuyLogo);
export default __webpack_public_path__ + "static/media/best_buy_logo.538f0074f634db8b6f06213b81b886b8.svg";
export { ForwardRef as ReactComponent };